import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import "./SubscribeModal.css";

// !!! Убедись, что путь к картинке правильный
// Если картинка в src/assets/images/, то путь будет примерно таким:
import characterImg from "../../media/kick head mask D (1).gif";

export function SubscribeModal({ open, title, onClose, children }) {
    const dialogRef = useRef(null);

    useEffect(() => {
        if (!open) return;

        function onKeyDown(event) {
            if (event.key === "Escape") onClose();
        }

        document.addEventListener("keydown", onKeyDown);

        setTimeout(() => {
            dialogRef.current?.focus();
        }, 0);

        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";

        return () => {
            document.removeEventListener("keydown", onKeyDown);
            document.body.style.overflow = previousOverflow;
        };
    }, [open, onClose]);

    if (!open) return null;

    return createPortal(
        <div className="subscribeOverlay" onMouseDown={onClose}>
            {/* --- ОБЕРТКА (Wrapper) --- */}
            {/* Она держит позицию для Окна и Персонажа вместе */}
            <div
                className="subscribeContentWrapper"
                onMouseDown={(event) => event.stopPropagation()}
            >
                {/* 1. ПЕРСОНАЖ (Лежит на фоне) */}
                <img
                    src={characterImg}
                    alt="Character"
                    className="subscribeCharacterBg"
                />

                {/* 2. МОДАЛЬНОЕ ОКНО (Сверху) */}
                <div
                    className="subscribeModal"
                    role="dialog"
                    aria-modal="true"
                    tabIndex={-1}
                    ref={dialogRef}
                >
                    <div className="subscribeModalHeader">
                        <h3 className="subscribeModalTitle">{title}</h3>
                        {/* <button className="subscribeCloseButton" onClick={onClose} aria-label="Close">
                            ✕
                        </button> */}
                    </div>

                    {children}
                </div>
            </div>
        </div>,
        document.body
    );
}